import { render } from "./MyShareDashboard.vue?vue&type=template&id=113e562f"
import script from "./MyShareDashboard.vue?vue&type=script&lang=js"
export * from "./MyShareDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__